import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LandingPage from './features/landing/pages/LandingPage/LandingPage';
import DAppPage from './features/betting/pages/DAppPage/DAppPage';
import PendingPage from './features/betting/pages/PendingPage/PendingPage';
import MyBetsPage from './features/betting/pages/MyBetsPage/MyBetsPage';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/how-it-works" element={<LandingPage />} />
        <Route path="/features" element={<LandingPage />} />
        <Route path="/architecture" element={<LandingPage />} />
        <Route path="/roadmap" element={<LandingPage />} />
        <Route path="/app" element={<DAppPage />} />
        <Route path="/pending" element={<PendingPage />} />
        <Route path="/my-bets" element={<MyBetsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
